export default "__VITE_ASSET__BcCKtV5Q__"